<template>
  <div class="registerMain">
    <div class="sz_register">
      <div class="sz_register_title">上海市绿色建筑协会会员系统</div>
      <div class="sz-code-box">
        <div class="code-img">
          <img src="../assets/qrcode2.png" />
        </div>
        <p>请关注绿色协会微信公众号</p>
      </div>
      <div class="sz_register_box">
        <img src="../assets/user.png" alt style="height: 23px;width: 20px;" />
        <div class="sz_register_line"></div>
        <input type="text" v-model="username" placeholder="请输入用户名" autocomplete="off" />
      </div>
      <div class="sz_register_box">
        <img src="../assets/password.png" alt style="height: 23px;width: 20px;" />
        <div class="sz_register_line"></div>
        <input type="password" v-model="password" placeholder="请输入密码" autocomplete="off" />
      </div>
      <div class="sz_register_box">
        <img src="../assets/email.png" alt style="height: 23px;width: 20px;" />
        <div class="sz_register_line"></div>
        <input type="text" v-model="email" placeholder="请输入邮箱" autocomplete="off" />
      </div>
      <div class="sz_register_box">
        <img src="../assets/company.png" alt style="height: 23px;width: 20px;" />
        <div class="sz_register_line"></div>
        <input type="text" v-model="companyname" placeholder="请输入公司名称" autocomplete="off"/>
      </div>
      <div class="sz_register_box">
        <img src="../assets/phone.png" alt style="height: 23px;width: 20px;" />
        <div class="sz_register_line"></div>
        <input type="text" v-model="phone" placeholder="请输入联系人手机" autocomplete="off"/>
      </div>
      <div class="sz_register_box">
        <img src="../assets/verification.png" alt style="height: 23px;width: 20px;" />
        <div class="sz_register_line"></div>
        <input type="text" v-model="verification" placeholder="请输入验证码" autocomplete="off" />
      </div>
      <canvas @click="draw(show_num)" id="canvas" width="90" height="35" style="position: absolute;top:345px;left: 445px;"></canvas>
      
      <div class="sz_register_button">
        <el-button type="primary" @click="toLogin" size="medium">返回登录</el-button>
        <el-button type="primary" @click="continueApply" size="medium" :loading="loading">继续申请</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from './../utils/apiService'
import { setTimeout } from 'timers'
import { setUserInfo } from '../utils/cache'
import util from './../utils/util'

export default {
  data () {
    return {
      loading: false,
      username: '',
      password: '',
      email: '',
      companyname: '',
      phone: '',
      verification: '',
      show_num: []
    }
  },
  mounted () {
    this.draw(this.show_num)
  },
  methods: {
    // 继续申请
    continueApply () {
      if (!this.username) {
        this.$message.error('用户名不能为空')
        return false
      }
      // 用户名验证
      const userNameReg = /[\u4e00-\u9fa5]/g
      if (this.username && userNameReg.test(this.username)) {
        this.$message.error('用户名不能含中文')
        return false
      }
      if (!this.email) {
        this.$message.error('邮箱不能为空')
        return false
      }
      // 邮箱验证
      const emailReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
      if (this.email && !emailReg.test(this.email)) {
        this.$message.error('请填写正确的邮箱格式')
        return false
      }
      if (!this.companyname) {
        this.$message.error('公司名称不能为空')
        return false
      }
      if (!this.password) {
        this.$message.error('密码不能为空')
        return false
      }
      if (!this.phone) {
        this.$message.error('手机号不能为空')
        return false
      }
      // 手机号验证
      const phoneReg = new RegExp(/^(?:(?:\+|00)86)?1[3-9][0-9]\d{8}$/)
      if (this.phone && !phoneReg.test(this.phone)) {
        this.$message.error('请填写正确的手机号')
        return false
      }
      // 验证码
      const num = this.show_num.join('')
      if (!this.verification) {
        this.$message.error('请输入验证码')
        return false
      } else if (this.verification !== num) {
        this.$message.error('验证码错误')
        return false
      }
      const params = {
        username: this.username,
        email: this.email,
        companyname: this.companyname,
        password: this.password,
        contactpersonphone: this.phone
      }
      this.loading = true
      API.memUserRegist(params).then(response => {
        if (response.resultCode === '0000') {
          this.loading = false
          this.$message.success('注册成功')
          const params = {
            username: this.username,
            password: this.password
          }
          API.memUserLogin(params).then(response => {
            if (response.resultCode === '0000') {
              setUserInfo(response.data)
            }
          })
          setTimeout(() => {
            this.$router.push('/notMemberMiddleWare')
          }, 1000)
        } else {
          this.loading = false
          this.$message.error(response.resultMsg)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    toLogin () {
      this.$router.push('/login')
    },
    draw: util.draw
  }
}
</script>

<style lang="scss" scoped>
.registerMain {
  width: 100%;
  height: 100%;
  background: url(../assets/bg.png) 100% 100% no-repeat;
  overflow: hidden;
  position: relative;
  margin: 0;
  padding: 0;
  text-align: center;
  footer {
    position: fixed;
    width: 100%;
    height: 30px;
    bottom: 0;
    background: linear-gradient(transparent, #326272);
    color: #fff;
    font-size: 14px;
  }
  #KBStatic {
    position: absolute;
    left: 0px;
    top: 0px;
  }
  .sz_register {
    width: 592px;
    height: 480px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: rgba(255, 255, 255, 1);
  }
  .sz_register_title {
    background: rgba(255, 255, 255, 1);
    height: 77px;
    font-size: 24px;
    color: #0096cc;
    line-height: 87px;
    font-weight: bold;
    margin-top: -35px;
  }
  .sz-code-box {
    float: left;
    margin-left: 15px;
    margin-top: 35px;
  }
  .sz-code-box .code-img {
    width: 240px;
    height: 240px;
  }
  .sz-code-box .code-img img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .sz-code-box p {
    text-align: center;
    font-size: 16px;
    color: #666666;
    line-height: 28px;
    margin: 0;
  }
  .sz_register_img {
    vertical-align: middle;
    width: 139px;
    height: 42px;
  }
  .sz_register_box {
    width: 268px;
    height: 46px;
    margin: 0 268px 15px;
    position: relative;
    border-bottom: 0.1px solid #737383;
  }
  .sz_register_box img {
    float: left;
    margin-top: 6px;
    width: 26px;
    height: 28px;
  }
  .sz_register_line {
    width: 1px;
    height: 25px;
    background: #979797;
    float: left;
    margin-top: 6px;
    margin-left: 13px;
  }
  .sz_register_box input {
    width: 200px;
    height: 38px;
    font-size: 16px;
    color: #333;
    line-height: 32px;
    margin-left: 3px;
    border: none;
    outline: none;
    border-radius: 5px;
  }
  .sz_register_button {
    padding-top: 15px;
  }
  .sz_register_bottom {
    background: #0096cc;
    /* border: 1px solid #979797; */
    border-radius: 20px;
    width: 255px;
    height: 36px;
    margin: 0 auto;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
  }
  .sz_register_bottom a {
    color: #ffffff;
    text-decoration: none;
  }
  .sz_register_bottom:hover {
    background: #1665c1;
  }
  .sz_small_title {
    color: #a4a4a4;
    font-size: 14px;
    float: right;
    margin-right: 110px;
    border-bottom: 1px solid #a4a4a4;
  }
  .password_remember {
    text-align: left;
    width: 357px;
    margin: auto;
    font-size: 12px;
  }
  .remenber_text {
    color: #a4a4a4;
  }
  .bottom_btns {
    color: #7c7c7c;
    font-size: 13px;
    cursor: pointer;
  }
  #w_fpwd {
    width: 100%;
    height: 72px;
    background: rgba(248, 248, 248, 1);
    opacity: 0.68;
  }
  .forgetpwd_hint > img,
  .forgetpwd_hint > span {
    vertical-align: middle;
  }
  .forgetpwd_hint:after {
    display: inline-block;
    width: 0;
    height: 100%;
    vertical-align: middle;
    content: "";
  }
}
</style>
